import { action } from "../../../actions";

const ACTION_PREFIX = "MAIN_NOTIFICATION_CENTER";

export const notificationsActionTypes = {
  addMessageNotificationCenter: `${ACTION_PREFIX}_ADD_MESSAGE`,
  closeNotificationCenter: `${ACTION_PREFIX}_CLOSE_NOTIFICATION_CENTER`,
};

export const addMessageNotificationCenter = (message, type) =>
  action(notificationsActionTypes.addMessageNotificationCenter, {
    message,
    type,
  });

export const closeNotificationCenter = () => action(notificationsActionTypes.closeNotificationCenter, {});
